// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";
import { themeOptions } from "styles/theme";

export const CartCheck = (props) => (
    <SvgIcon viewBox="0 0 24 20" {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-850.000000, -449.000000)">
                <g transform="translate(796.000000, 331.000000)">
                    <g transform="translate(18.000000, 40.000000)">
                        <g transform="translate(36.000000, 78.000000)">
                            <rect x="0" y="0" width="24" height="24"></rect>
                            <g
                                transform="translate(1.000000, 2.000000)"
                                stroke={props.color ?? themeOptions.palette.primary1Color}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path
                                    d="M0,0 L4,0 L6.68,13.3896681 C6.86873697,14.3398761 7.71138394,15.0181901 8.68,14.9996282 L18.4,14.9996282 C19.3686161,15.0181901 20.211263,14.3398761 20.4,13.3896681 L22,4.99987606"
                                    strokeWidth="2"
                                ></path>
                                <polyline strokeWidth="2" points="18.25 3 13.09375 9.3 10 6.15"></polyline>
                                <line x1="7.49625" y1="19.5" x2="7.50375" y2="19.5" strokeWidth="3"></line>
                                <line x1="18.49625" y1="19.5" x2="18.50375" y2="19.5" strokeWidth="3"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default CartCheck;
